import Carousel from './carousel';

export default class Page {
	constructor () {
	}

	init () {
		console.log('Init page');

		const carou = new Carousel();
		carou.init();
	}
}
